import { render, staticRenderFns } from "./MappedImageModal.vue?vue&type=template&id=6c564e02&scoped=true"
import script from "./MappedImageModal.vue?vue&type=script&lang=js"
export * from "./MappedImageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c564e02",
  null
  
)

export default component.exports